// React Lib
import React, { useEffect, useState } from "react";
// Component Styles
import { useStyles } from "./DeviceLimitStyles";
// @otg-one/ui_components/components
import { Chart, Typography, OverflowMenu, EditDeviceLimit } from "../index";
// @otg-one/ui_components/icons
import { ShowMoreHorizontal } from "../../sap_icons";
import { Device } from "../../icons";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY, DeviceLimitType } from "../../constants";
export const DeviceLimit = (props) => {
    const classes = useStyles(props);
    const { type, data, handleSubmitDeviceLimit, style, textStatus, textCount, textActiveDevice, textDeviceLimitLeft, textDeviceLimit, textChangeDeviceLimit } = props;
    const activeDevice = data.activeDevice == null ? 0 : data.activeDevice;
    const deviceLimit = data.deploymentEnv === 0 || data.deviceLimit == null ? data.defaultDeviceLimit : data.deviceLimit;
    const deviceLimitLeft = deviceLimit - activeDevice;
    const deviceLimitData = [
        [textStatus, textCount],
        [textActiveDevice, activeDevice],
        [textDeviceLimitLeft, deviceLimitLeft]
    ];
    let changeDeviceLimitDisabled = false;
    if (type === DeviceLimitType.SYSTEM && data.deploymentEnv === 0) {
        deviceLimitData[1][0] = `Parallel ${deviceLimitData[1][0]}`;
        deviceLimitData[2][0] = `Parallel ${deviceLimitData[2][0]}`;
        changeDeviceLimitDisabled = true;
    }
    useEffect(() => {
        if (data.textKey === "482e610668567b783f1f2ab684a98ed4") {
            deviceLimitData[1][1] = 15;
        }
        else if (data.textKey === "386baf44424675ae2198938824c9ab2d") {
            deviceLimitData[1][1] = 13;
        }
        else if (data.textKey === "25493550db2679aeb55ea4f757546545") {
            deviceLimitData[1][1] = 17;
        }
    }, []);
    const [editDeviceLimitDialogOpen, setEditDeviceLimitDialogOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const handleOpenEditDeviceLimitDialog = () => { setEditDeviceLimitDialogOpen(true); };
    const handleCloseEditDeviceLimitDialog = () => { setEditDeviceLimitDialogOpen(false); };
    const handleClickShowMoreIcon = (event) => {
        event.stopPropagation();
        if (!anchorEl) {
            setAnchorEl(event.currentTarget);
        }
        ;
    };
    return (React.createElement("div", { className: classes.deviceLimitContainer, style: style },
        React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, size: 18, color: Color.neutral[900] }, textDeviceLimit),
        React.createElement("div", { style: { position: "relative", marginTop: 30 } },
            React.createElement(Chart, { chartType: "PieChart", chartData: deviceLimitData, chartWidth: "100%", chartHeight: "380px", chartOptions: {
                    chartArea: {
                        left: 20,
                        right: 20,
                        top: 5,
                        bottom: 100,
                        width: "100%",
                        height: "380",
                    },
                    backgroundColor: "transparent",
                    colors: [Color.primary[600], Color.neutral[200]],
                    legend: {
                        position: "bottom",
                        textStyle: {
                            fontFamily: FONT_FAMILY.ROBOTO_LIGHT,
                            fontSize: 12,
                            color: Color.neutral[900],
                        }
                    },
                    pieHole: 0.6,
                    pieSliceText: 'none',
                    tooltip: { isHtml: true, trigger: "visible" }
                } }),
            React.createElement("div", { style: { position: "absolute", top: '25%', left: data.deploymentEnv === 0 ? '52%' : '47%' } },
                React.createElement(Device, { style: { width: 24, height: 24, color: Color.primary[600], marginLeft: data.deploymentEnv === 0 ? -18 : 5 } }),
                React.createElement("div", { style: { display: 'flex', marginTop: -10, marginLeft: data.deploymentEnv === 0 ? -40 : (deviceLimitData[1][1] > 10 ? -40 : -20) } },
                    React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 48, color: Color.neutral[400], className: classes.deviceLimitTypographyNumber }, deviceLimitData[1][1]),
                    React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 18, color: Color.neutral[600], className: classes.deviceLimitTypographyCapacity }, `/ ${parseInt(`${deviceLimitData[1][1]}`, 10) + parseInt(`${deviceLimitData[2][1]}`, 10)}`)))),
        React.createElement(ShowMoreHorizontal, { className: classes.deviceLimitShowMoreHorizontal, onClick: handleClickShowMoreIcon }),
        !changeDeviceLimitDisabled && (React.createElement(OverflowMenu, { anchorElement: anchorEl, setAnchorEl: setAnchorEl, menuItems: [
                {
                    text: textChangeDeviceLimit,
                    onClick: () => {
                        handleOpenEditDeviceLimitDialog();
                    }
                }
            ] })),
        React.createElement(EditDeviceLimit, { open: editDeviceLimitDialogOpen, onClose: handleCloseEditDeviceLimitDialog, data: {
                textName: data.textName,
                deviceLimit: data.deviceLimit,
                defaultDeviceLimit: data.defaultDeviceLimit,
            }, type: type, handleSubmitDeviceLimit: handleSubmitDeviceLimit })));
};
DeviceLimit.defaultProps = {
    type: DeviceLimitType.CLIENT,
    data: {
        textKey: "1",
        textName: "Data Name",
        activeDevice: 7,
        deviceLimit: 25,
        defaultDeviceLimit: 25,
        deploymentEnv: 1
    },
    handleSubmitDeviceLimit: (data) => { },
    textStatus: "Status",
    textCount: "Count",
    textActiveDevice: "Active Device",
    textDeviceLimitLeft: "Device Limit Left",
    textDeviceLimit: "Device Limit",
    textChangeDeviceLimit: "Change Device Limit",
};
export default React.memo(DeviceLimit);
